import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a1242992ab6ae00146e53c3/fandomcasefiles/src/app/sign-up-login-screen/components/AuthScreen.tsx");
